import { stickyStyles } from '../table.utils';
import { CSSObject, Theme } from '../../base-components';
import { ITableStickyColumn } from '../table.interfaces';
import { CellType } from '../table.consts';
import {
    CellCheckboxSkeleton,
    CellDateAndTimeSkeleton,
    CellIconSkeleton,
    CellLabelSkeleton,
    CellPersonSkeleton,
    CellSingleTextLineSkeleton,
    CellRangeBlocksSkeleton,
    CellTagsSkeleton,
    CellMenuSkeleton,
    CellIconButtonSkeleton,
} from './CellsSkeletons';
import CellSingleTextLine from './CellSingleTextLine';
import CellCheckbox from './CellCheckbox';
import CellPerson from './CellPerson';
import CellDateAndTime from './CellDateAndTime';
import CellLabel from './CellLabel';
import CellMenu from './CellMenu';
import CellIcon from './CellIcon';
import CellRangeBlocks from './CellRangeBlocks';
import CellIconButton from './CellIconButton';
import CellTags from './CellTags';

export const allCells: Record<CellType, React.FC<any>> = {
    [CellType.SingleTextLine]: CellSingleTextLine,
    [CellType.Checkbox]: CellCheckbox,
    [CellType.Person]: CellPerson,
    [CellType.DateAndTime]: CellDateAndTime,
    [CellType.Label]: CellLabel,
    [CellType.Menu]: CellMenu,
    [CellType.Icon]: CellIcon,
    [CellType.RangeBlocks]: CellRangeBlocks,
    [CellType.IconButton]: CellIconButton,
    [CellType.Tags]: CellTags,
};

export const allSkeletons: Record<CellType, React.FC<any>> = {
    [CellType.SingleTextLine]: CellSingleTextLineSkeleton,
    [CellType.Checkbox]: CellCheckboxSkeleton,
    [CellType.Person]: CellPersonSkeleton,
    [CellType.DateAndTime]: CellDateAndTimeSkeleton,
    [CellType.Label]: CellLabelSkeleton,
    [CellType.Menu]: CellMenuSkeleton,
    [CellType.Icon]: CellIconSkeleton,
    [CellType.RangeBlocks]: CellRangeBlocksSkeleton,
    [CellType.IconButton]: CellIconButtonSkeleton,
    [CellType.Tags]: CellTagsSkeleton,
};

export const baseCellStyles = (
    theme: Theme,
    stickyColumn?: ITableStickyColumn,
    rowStickyWidths?: Array<number>,
    columnIndex?: number,
    isSelected?: boolean
): CSSObject => {
    const hasStickyColumn = stickyColumn?.side && stickyColumn?.width;
    const stickyStylesObj = hasStickyColumn
        ? stickyStyles(
              theme,
              stickyColumn?.side,
              columnIndex,
              stickyColumn?.width,
              rowStickyWidths,
              false,
              isSelected
          )
        : {};
    return {
        ...stickyStylesObj,
        padding: theme.spacing(0.5),
    };
};
